<template>
  <div>
    <form-input type="range" v-model="model" min="1" max="1OO" :disabled="disabled" :required="required" />
    <div slot="help">
      <span class="pull-right text-muted">Position : {{model}}</span>
      <span v-if="model == 100" class="text-muted">En dernier</span>
      <span v-else-if="model == 1" class="text-orange text-semibold">En premier</span>
      <span v-else-if="model >= 67" class="text-slate">Vers la fin</span>
      <span v-else-if="model <= 33" class="text-green-700 text-semibold">Vers le début</span>
      <span v-else class="text-blue-600">Vers le milieu</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [Number, String],
    disabled: Boolean,
    required: Boolean
  },
  computed: {
    model: {
      get() {
        return 100 - (parseInt(this.value, 10) || 0);
      },
      set(value) {
        const order = 100 - (value || 0);
        this.$emit("input", order);
        this.$emit("change", order);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FormOrder.vue